

//function sendLog(logLevel, message, additionalData{})
function sendLog(logLevel, message, additionalData)
{
  /*
  const logEntry = {
    timestamp: new Date().toISOString(),
    level: logLevel,
    message: message,
    data: additionalData
  };

  const logData = JSON.stringify(logEntry);

  try {
  fetch('/api/log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: logData
  })
    .then(response =>
    {
      if (!response.ok)
      {
        throw new Error('Failed to send log');
      }
    })
    .catch(error =>
    {
      console.error('Error sending log:', error);
    });
  } catch (exception) {
    console.error('Error sending log:', exception);
  }
    */
}
window.sendLog = sendLog;
